export * from './colorpicker-demo.component';
